import React from "react";
import {
  Box,
  Grid,
  TextField,
  IconButton,
  ToggleButtonGroup,
  ToggleButton,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import IosShareIcon from "@mui/icons-material/IosShare";

const OrderFiltersMobile = ({
  searchTerm,
  setSearchTerm,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  onExport,
  reviewedFilter,
  setReviewedFilter,
}) => {
  return (
    <Grid container spacing={1.5} mb={1}>
      {/* Search + pills + export on one row */}
      <Grid item xs={12}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: 180,
              border: "1px solid rgba(0,0,0,0.18)",
              borderRadius: "8px",
              bgcolor: "white",
              height: 38,
              px: 1,
              "&:focus-within": { borderColor: "#1976d2", boxShadow: "0 0 0 2px rgba(25,118,210,0.12)" },
              transition: "box-shadow 0.15s, border-color 0.15s",
            }}
          >
            <SearchIcon sx={{ color: "text.disabled", fontSize: 18, mr: 0.8, flexShrink: 0 }} />
            <input
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="חיפוש..."
              style={{
                flex: 1,
                border: "none",
                outline: "none",
                fontSize: "0.82rem",
                background: "transparent",
                color: "inherit",
                fontFamily: "inherit",
                minWidth: 0,
              }}
            />
            {searchTerm && (
              <IconButton size="small" onClick={() => setSearchTerm("")} sx={{ p: 0.3 }}>
                <ClearIcon sx={{ fontSize: 16, color: "text.disabled" }} />
              </IconButton>
            )}
          </Box>

          <ToggleButtonGroup
            value={reviewedFilter}
            exclusive
            onChange={(_, val) => val && setReviewedFilter(val)}
            sx={{
              bgcolor: "rgba(0,0,0,0.05)",
              borderRadius: "8px",
              p: "3px",
              "& .MuiToggleButtonGroup-grouped": {
                border: "none !important",
                borderRadius: "5px !important",
                px: 1.2,
                py: 0,
                height: 28,
                fontSize: "0.72rem",
                fontWeight: 500,
                textTransform: "none",
                color: "text.secondary",
              },
            }}
          >
            <ToggleButton value="all" sx={{ "&.Mui-selected": { bgcolor: "white", color: "text.primary", boxShadow: "0 1px 3px rgba(0,0,0,0.1)" } }}>
              הכל
            </ToggleButton>
            <ToggleButton value="pending" sx={{ "&.Mui-selected": { bgcolor: "#dbeafe", color: "#1e40af" } }}>
              חדשים
            </ToggleButton>
            <ToggleButton value="reviewed" sx={{ "&.Mui-selected": { bgcolor: "#fef3c7", color: "#92400e" } }}>
              ממתינים
            </ToggleButton>
          </ToggleButtonGroup>

          <Box sx={{ flex: 1 }} />
          <IconButton onClick={onExport}>
            <IosShareIcon style={{ color: "#217346" }} />
          </IconButton>
        </Box>
      </Grid>

      {/* Date range */}
      <Grid item xs={6}>
        <TextField
          label="מתאריך"
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          InputProps={{
            endAdornment: startDate && (
              <InputAdornment position="end">
                <IconButton size="small" onClick={() => setStartDate("")} edge="end">
                  <ClearIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ),
          }}
          size="small"
          fullWidth
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          label="עד תאריך"
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          InputProps={{
            endAdornment: endDate && (
              <InputAdornment position="end">
                <IconButton size="small" onClick={() => setEndDate("")} edge="end">
                  <ClearIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ),
          }}
          size="small"
          fullWidth
        />
      </Grid>
    </Grid>
  );
};

export default OrderFiltersMobile;
